export const MAX_FILE_SIZE_BYTES = 50 * 1024 * 1024; // 50MB
export const MAX_FILE_SIZE_MB = 50;
export const MAX_FILES_PER_REQUEST = 5;
export const FILE_EXPIRY_HOURS = 24;
export const POLLING_INTERVAL_MS = 2000;
export const CONVERSION_TIMEOUT_MS = 5 * 60 * 1000; // 5 minutes
